import { put, select, fork, take, race } from "redux-saga/effects";
import { hide } from "redux-modal";
import { dispatchGeneratorFunc } from "../helpers/helpers";
import { associatedInsightWithActionEvent } from "../../../utils/eventTracking";

const INITIAL_STATE = {
  isAssociating: false,
  complete: false,
  error: undefined,
};

export const ASSOCIATE_RULE_EQUIP = "bonfire/_BETA/triage/ASSOCIATE_RULE_EQUIP";
export const ASSOCIATE_RULE_EQUIP_REQUEST =
  "bonfire/_BETA/triage/ASSOCIATE_RULE_EQUIP_REQUEST";
export const ASSOCIATE_RULE_EQUIP_REQUEST_SUCCESS =
  "bonfire/_BETA/triage/ASSOCIATE_RULE_EQUIP_REQUEST_SUCCESS";
export const ASSOCIATE_RULE_EQUIP_REQUEST_FAIL =
  "bonfire/_BETA/triage/ASSOCIATE_RULE_EQUIP_REQUEST_FAIL";
export const ASSOCIATE_RULE_EQUIP_COMPLETE =
  "bonfire/_BETA/triage/ASSOCIATE_RULE_EQUIP_COMPLETE";

export function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case ASSOCIATE_RULE_EQUIP:
      return {
        ...state,
        isAssociating: true,
      };
    case ASSOCIATE_RULE_EQUIP_REQUEST:
      return {
        ...state,
        complete: false,
        error: undefined,
      };
    case ASSOCIATE_RULE_EQUIP_REQUEST_SUCCESS:
      return {
        ...state,
        complete: true,
        error: undefined,
      };
    case ASSOCIATE_RULE_EQUIP_REQUEST_FAIL:
      return {
        ...state,
        complete: true,
        error: action.error,
      };
    case ASSOCIATE_RULE_EQUIP_COMPLETE:
      return {
        ...state,
        isAssociating: false,
      };
    default: {
      return state;
    }
  }
}

/** @param {{ equipRuleIds?: number[], issueKey: string }} params */
export const associateEquipRule = ({ equipRuleIds = [], issueKey }) => ({
  type: ASSOCIATE_RULE_EQUIP,
  equipRuleIds,
  issueKey,
});

export const postAssociateEquipRule = ({
  equipRuleIds = [],
  issueKey,
  token,
}) => ({
  types: [
    ASSOCIATE_RULE_EQUIP_REQUEST,
    ASSOCIATE_RULE_EQUIP_REQUEST_SUCCESS,
    ASSOCIATE_RULE_EQUIP_REQUEST_FAIL,
  ],
  promise: (client) =>
    client.post("/v2/actions/associate", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        equipRuleIds,
        actionId: issueKey,
      },
    }),
});

const getAuthUser = (state) => state.auth.user;
const getBetaIssues = (state) =>
  state.betaIssues && state.betaIssues.data && state.betaIssues.data.length > 0
    ? state.betaIssues.data
    : [];
export function* associateEquipRuleFlow() {
  while (true) {
    const { issueKey, equipRuleIds } = yield take(ASSOCIATE_RULE_EQUIP);

    try {
      const user = yield select(getAuthUser);
      const betaIssues = yield select(getBetaIssues);

      // Check that user has necessary permissions to make request
      if (!user.rolesRestriction) throw Error("Unable to authenticate user");
      // Validate that an issueKey has been given
      if (!issueKey) throw Error("No issueKey given");
      // validate that at least one equipRuleId has been given
      if (equipRuleIds.length < 1) throw Error("No equip rules given");

      yield fork(dispatchGeneratorFunc, postAssociateEquipRule, {
        token: user.token,
        issueKey,
        equipRuleIds,
      });

      // TODO: Handle error state properly
      const { success, failure } = yield race({
        success: take(ASSOCIATE_RULE_EQUIP_REQUEST_SUCCESS),
        failure: take(ASSOCIATE_RULE_EQUIP_REQUEST_FAIL),
      });

      if (failure) {
        throw new Error("Failed to associate");
      }

      if (success) {
        // Track user event on success for analytics
        associatedInsightWithActionEvent(betaIssues, success.result);

        yield put(hide("TRIAGE_ACTION_MODAL"));

        // Update isAssociating flag so UI is no longer blocked
        yield put({ type: ASSOCIATE_RULE_EQUIP_COMPLETE });
      }
    } catch (err) {
      console.error(
        `Something went wrong attempting to associate equip rule: ${err}`
      );
    }
  }
}
